export const SMALL_MOBILE_IMAGE_RESIZE_WIDTH = 320
export const MEDIUM_MOBILE_IMAGE_RESIZE_WIDTH = 480
export const LARGE_MOBILE_IMAGE_RESIZE_WIDTH = 640
export const DESKTOP_IMAGE_RESIZE_WIDTH = 1024
export const WIDE_SCREEN_IMAGE_RESIZE_WIDTH = 1600
export const STICKY_FOOTER_SCROLL_THRESHOLD = 100
